/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function () {
  'use strict';
  var TlpsTraslocoDatiAggiuntiviCtrl = function (
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    traslocoTelepassSrvc,
    uiGridConstants,
    userSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.gridApi = null;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.traslocoTelepassSrvc = traslocoTelepassSrvc;

    // Spinner
    this.spinner = this.traslocoTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;

    // Opzioni della tabella dei conti
    this.gridOptions = {};
    this.tableHeight = 0;
    this.contiCorrenti = [];

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE BOTTONI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name datiValidi
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Verifica che i campi obbligatori siano valorizzati correttamente.
     */
    this.traslocoTelepassSrvc.datiValidi = function () {
      return true;
    };

    this.init = function () {
      self.dataRilascioDocumento = self.traslocoTelepassSrvc.formattazioneData(
        self.traslocoTelepassSrvc.datiCliente.documentoIdentita.dataRilascio
      );

      self.dataScadenzaDocumento = self.traslocoTelepassSrvc.formattazioneData(
        self.traslocoTelepassSrvc.datiCliente.documentoIdentita.dataScadenza
      );

      self.spinner.showSpinner = false;
    };

    this.init();
  };

  TlpsTraslocoDatiAggiuntiviCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsTraslocoTelepassSrvc',
    'uiGridConstants',
    'TlpsUserSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDatiAggiuntivi/tlpsTraslocoDatiAggiuntivi.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsTraslocoDatiAggiuntiviComponent = {
    bindings: {},
    controller: TlpsTraslocoDatiAggiuntiviCtrl,
    controllerAs: 'traslocoDatiAggiuntiviCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component(
      'tlpsTraslocoDatiAggiuntivi',
      TlpsTraslocoDatiAggiuntiviComponent
    );
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDatiAggiuntivi/tlpsTraslocoDatiAggiuntivi.cmpt.js
// module id = 22
// module chunks = 0